import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { PermissionService } from '@shared/service/permission.service';
import {TranslateContext} from '@shared/pipes/translate.pipe';
@Component({
	selector: 'amd-coronavirus-dialog',
	templateUrl: './coronavirus-dialog.component.html',
	styleUrls: ['./coronavirus-dialog.component.scss']
})
export class CoronavirusDialogComponent {
	hasDelivery: boolean;
	firstView: boolean;
	translateContext: TranslateContext = TranslateContext.CORE;
	
	constructor(
		public permissionService: PermissionService,
		private dialogRef: MatDialogRef<CoronavirusDialogComponent>,
	) {
		this.hasDelivery = this.permissionService.hasPermissions('delivery_orders');
		this.firstView = true;
	}

	closeDialog(): void {
		if (this.hasDelivery) {
			if (!this.firstView) {
				this.dialogRef.close();
			}
		} else {
			this.dialogRef.close();
		}
		this.firstView = false;
	}
}
